import RecipePage from "./RecipePage";

export default RecipePage;